import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import '../Styling/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>QuantifyLogic Solutions Pvt Ltd</h3>
          <p>Global Excellence in delivering innovative technology solutions and professional excellence.</p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/aboutus">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contactus">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Our Services</h4>
          <ul>
            <li><Link to="/services/application-development">Application Development</Link></li>
            <li><Link to="/services/software-testing">Software Testing</Link></li>
            <li><Link to="/services/it-consulting">IT Consulting</Link></li>
            <li><Link to="/services/it-training">IT Training</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <ul className="contact-info">
            <li>📍 Kamalraj Pasaydan, 2nd Floor, Office No D206, Alandi Rd, above Global Mart Dighi, Pune, Maharashtra 411015</li>
            <li>📞 +91 9890142308</li>
            <li>✉️ info@quantifylogic.com</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom" style={{ position: 'relative' }}>
        <p>&copy; {new Date().getFullYear()} QuantifyLogic Solutions Pvt Ltd. All rights reserved. </p>
        <Link
          to="/admin"
          className="admin-login-link"
          style={{
            position: 'absolute',
            right: 24,
            bottom: 8,
            color: '#1976d2',
            textDecoration: 'underline',
            fontSize: 15,
            opacity: 0.8,
            fontWeight: 500
          }}
        >
          Admin Login
        </Link>
      </div>
    </footer>
  );
};

export default Footer; 